import { IGetEventAttendee } from '@interfaces/Events'
import { GroupClassList } from '@interfaces/MyLesson'
import { LessonDate } from '@layouts/MySchedule/Layout/interface'
import { DATE_FORMAT } from '@utils/constants'
import { ATTENDEE_STATUS } from '@utils/constants/events'
import { groupBy, mapValues } from 'lodash'
import PortalBerlitzEventAttendee from './BerlitzEventAttendee'
import moment from 'moment'
import { GroupClassListItem } from '@interfaces/MySchedule'

class PortalBerlitzUserEvents {
  eventAttendees: IGetEventAttendee[]
  userTZ: string

  constructor(eventAttendees: IGetEventAttendee[] = [], userTZ: string) {
    this.eventAttendees = eventAttendees || []
    this.userTZ = userTZ
  }

  get UserEvents() {
    return this.eventAttendees.map(event => new PortalBerlitzEventAttendee(event, false, this.userTZ))
  }

  get ActiveUserEvents() {
    return this.UserEvents.filter(
      Event => Event.event.berlitzEventAttendeeInfo.AttendeeStatus !== ATTENDEE_STATUS.CANCELLED
    )
  }

  get MyScheduleEvents(): GroupClassListItem[] {
    return this.ActiveUserEvents.map(({ Id, Type, RawStartDatetime, RawEndDatetime, AttendeeId, event }) => {
      return {
        Id,
        Type,
        StartTime: RawStartDatetime,
        EndTime: RawEndDatetime,
        SessionId: AttendeeId,
        Event: event.berlitzEventAttendeeInfo,
        // stubs
        PrevInstructors: [],
        NextInstructors: [],
        Comments: [],
        SessionInfoList: [],
        MaterialList: [],
        LastMaterialList: [],
        StudentGroupId: '',
        ProgramType: '',
        ProgramId: '',
        Language: '',
        ProgramLanguage: '',
        LessonRegistered: false,
        SessionMetaData: {
          StartTime: '',
          EndTime: '',
          Index: 0,
        },
        MINote: '',
        VirtualClassRoomProvider: '',
        DeliveryMode: '',
        CounsellingNextSteps: '',
        CounsellingSessionComments: '',
        StudentGroupInfo: {
          Id: '',
        },
        TotalLessons: 0,
        LessonsTaken: 0,
      }
    })
  }

  getMyScheduleEventsByDate(date: moment.Moment): GroupClassListItem[] {
    return this.MyScheduleEvents.filter(({ StartTime, EndTime }) => {
      return date.isSame(StartTime, 'date') || date.isSame(EndTime, 'date')
    })
  }

  get MyLessonEvents(): GroupClassList[] {
    return this.ActiveUserEvents.map(({ Id, Type, RawStartDatetime, RawEndDatetime, event }) => {
      return {
        Id,
        Type,
        StartTime: RawStartDatetime,
        EndTime: RawEndDatetime,
        Event: event.berlitzEventAttendeeInfo,
        // stubs
        GroupName: '',
        LearningCenter: '',
        Classroom: '',
        FirstLesson: false,
        HighestRating: false,
        PaceWarning: false,
        ReportNeeded: false,
        Attachment: false,
        Notes: false,
        Status: '',
        GroupMaterials: [],
        MaterialList: {
          GroupName: '',
          Materials: [],
          LastMaterials: [],
          Medias: [],
        },
        LastMaterialList: [],
        GroupComments: [],
        Comments: [],
        LessonHistory: {
          LastLessons: [],
          LessonsWithMe: [],
          FlexLastLessons: [],
          FlexLessonsWithMe: [],
          isProgramOnline: false,
        },
        Profiles: [],
        SessionInfoList: [],
        StudentGroupId: '',
        DisplayTime: '',
        Warning: false,
        ProgramType: '',
        ProgramId: '',
        VirtualClassRoomProvider: '',
        ProgramName: '',
        LessonRegistered: false,
        InstructorToMINote: '',
        MINote: '',
        CustomerId: '',
        SessionId: '',
        SessionMetaData: {
          StartTime: '',
          EndTime: '',
          Index: 0,
        },
      }
    })
  }

  getMyLessonEventsByDate(date: moment.Moment): GroupClassList[] {
    return this.MyLessonEvents.filter(({ StartTime, EndTime }) => {
      return date.isSame(StartTime, 'date') || date.isSame(EndTime, 'date')
    })
  }

  getCalendarDates(lessonDates?: LessonDate[]): LessonDate[] {
    let eventDates: LessonDate[] = []
    mapValues(
      groupBy(this.ActiveUserEvents.map(Event => Event.StartDatetime.format(DATE_FORMAT.BASIC))),
      (dates = [], key) => {
        eventDates = [
          ...eventDates,
          {
            date: key,
            numberOfLessons: dates.length,
          },
        ]
      }
    )
    return Object.values(
      [...(lessonDates || []), ...eventDates].reduce((acc, { date, numberOfLessons }) => {
        acc[date] = { date, numberOfLessons: (acc[date] ? acc[date].numberOfLessons : 0) + numberOfLessons }
        return acc
      }, {})
    )
  }
}

export default PortalBerlitzUserEvents
